// extracted by mini-css-extract-plugin
export default {"customLink":"CustomLink_customLink__qu+sH","customLinkContent":"CustomLink_customLinkContent__NIU-z","customLinkIcon":"CustomLink_customLinkIcon__TO8Vn"};